import { styled } from '@grupoboticario/flora-react';

export default {
  TagContainer: styled('div', {
    display: 'flex',
    alignItems: 'flex-end',
    marginLeft: '$4',
    paddingTop: '$2',
  }),
};
